module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Icons\n      "), _c('small', [_vm._v("a set of beautiful icons")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Icons")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#fa-icons",
      "data-toggle": "tab"
    }
  }, [_vm._v("Font Awesome")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#glyphicons",
      "data-toggle": "tab"
    }
  }, [_vm._v("Glyphicons")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "fa-icons"
    }
  }, [_c('section', {
    attrs: {
      "id": "new"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("66 New Icons in 4.4")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-500px"
  }), _vm._v(" fa-500px")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-amazon"
  }), _vm._v(" fa-amazon")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale"
  }), _vm._v(" fa-balance-scale")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-0"
  }), _vm._v(" fa-battery-0\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-1"
  }), _vm._v(" fa-battery-1\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-2"
  }), _vm._v(" fa-battery-2\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-3"
  }), _vm._v(" fa-battery-3\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-4"
  }), _vm._v(" fa-battery-4\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-empty"
  }), _vm._v(" fa-battery-empty")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-full"
  }), _vm._v(" fa-battery-full")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-half"
  }), _vm._v(" fa-battery-half")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-quarter"
  }), _vm._v(" fa-battery-quarter")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-three-quarters"
  }), _vm._v("\n                    fa-battery-three-quarters\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-black-tie"
  }), _vm._v(" fa-black-tie")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar-check-o"
  }), _vm._v(" fa-calendar-check-o\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar-minus-o"
  }), _vm._v(" fa-calendar-minus-o\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar-plus-o"
  }), _vm._v(" fa-calendar-plus-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar-times-o"
  }), _vm._v(" fa-calendar-times-o\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-diners-club"
  }), _vm._v(" fa-cc-diners-club")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-jcb"
  }), _vm._v(" fa-cc-jcb")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chrome"
  }), _vm._v(" fa-chrome")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-clone"
  }), _vm._v(" fa-clone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-commenting"
  }), _vm._v(" fa-commenting")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-commenting-o"
  }), _vm._v(" fa-commenting-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-contao"
  }), _vm._v(" fa-contao")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-creative-commons"
  }), _vm._v(" fa-creative-commons\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-expeditedssl"
  }), _vm._v(" fa-expeditedssl")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-firefox"
  }), _vm._v(" fa-firefox")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fonticons"
  }), _vm._v(" fa-fonticons")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-genderless"
  }), _vm._v(" fa-genderless")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-get-pocket"
  }), _vm._v(" fa-get-pocket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gg"
  }), _vm._v(" fa-gg")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gg-circle"
  }), _vm._v(" fa-gg-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-grab-o"
  }), _vm._v(" fa-hand-grab-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-lizard-o"
  }), _vm._v(" fa-hand-lizard-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-paper-o"
  }), _vm._v(" fa-hand-paper-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-peace-o"
  }), _vm._v(" fa-hand-peace-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-pointer-o"
  }), _vm._v(" fa-hand-pointer-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-rock-o"
  }), _vm._v(" fa-hand-rock-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-scissors-o"
  }), _vm._v(" fa-hand-scissors-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-spock-o"
  }), _vm._v(" fa-hand-spock-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-stop-o"
  }), _vm._v(" fa-hand-stop-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass"
  }), _vm._v(" fa-hourglass")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-1"
  }), _vm._v(" fa-hourglass-1\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-2"
  }), _vm._v(" fa-hourglass-2\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-3"
  }), _vm._v(" fa-hourglass-3\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-end"
  }), _vm._v(" fa-hourglass-end")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-half"
  }), _vm._v(" fa-hourglass-half")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-o"
  }), _vm._v(" fa-hourglass-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-start"
  }), _vm._v(" fa-hourglass-start")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-houzz"
  }), _vm._v(" fa-houzz")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-i-cursor"
  }), _vm._v(" fa-i-cursor")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-industry"
  }), _vm._v(" fa-industry")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-internet-explorer"
  }), _vm._v(" fa-internet-explorer\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map"
  }), _vm._v(" fa-map")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-o"
  }), _vm._v(" fa-map-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-pin"
  }), _vm._v(" fa-map-pin")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-signs"
  }), _vm._v(" fa-map-signs")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mouse-pointer"
  }), _vm._v(" fa-mouse-pointer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-object-group"
  }), _vm._v(" fa-object-group")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-object-ungroup"
  }), _vm._v(" fa-object-ungroup")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-odnoklassniki"
  }), _vm._v(" fa-odnoklassniki")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-odnoklassniki-square"
  }), _vm._v("\n                    fa-odnoklassniki-square\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-opencart"
  }), _vm._v(" fa-opencart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-opera"
  }), _vm._v(" fa-opera")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-optin-monster"
  }), _vm._v(" fa-optin-monster")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-registered"
  }), _vm._v(" fa-registered")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-safari"
  }), _vm._v(" fa-safari")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sticky-note"
  }), _vm._v(" fa-sticky-note")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sticky-note-o"
  }), _vm._v(" fa-sticky-note-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-television"
  }), _vm._v(" fa-television")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trademark"
  }), _vm._v(" fa-trademark")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tripadvisor"
  }), _vm._v(" fa-tripadvisor")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tv"
  }), _vm._v(" fa-tv\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-vimeo"
  }), _vm._v(" fa-vimeo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-wikipedia-w"
  }), _vm._v(" fa-wikipedia-w")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-y-combinator"
  }), _vm._v(" fa-y-combinator")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-yc"
  }), _vm._v(" fa-yc\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "web-application"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Web Application Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-adjust"
  }), _vm._v(" fa-adjust")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-anchor"
  }), _vm._v(" fa-anchor")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-archive"
  }), _vm._v(" fa-archive")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-area-chart"
  }), _vm._v(" fa-area-chart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrows"
  }), _vm._v(" fa-arrows")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrows-h"
  }), _vm._v(" fa-arrows-h")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrows-v"
  }), _vm._v(" fa-arrows-v")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-asterisk"
  }), _vm._v(" fa-asterisk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at"
  }), _vm._v(" fa-at")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-automobile"
  }), _vm._v(" fa-automobile\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale"
  }), _vm._v(" fa-balance-scale")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ban"
  }), _vm._v(" fa-ban")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bank"
  }), _vm._v(" fa-bank "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bar-chart"
  }), _vm._v(" fa-bar-chart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bar-chart-o"
  }), _vm._v(" fa-bar-chart-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-barcode"
  }), _vm._v(" fa-barcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bars"
  }), _vm._v(" fa-bars")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-0"
  }), _vm._v(" fa-battery-0\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-1"
  }), _vm._v(" fa-battery-1\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-2"
  }), _vm._v(" fa-battery-2\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-3"
  }), _vm._v(" fa-battery-3\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-4"
  }), _vm._v(" fa-battery-4\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-empty"
  }), _vm._v(" fa-battery-empty")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-full"
  }), _vm._v(" fa-battery-full")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-half"
  }), _vm._v(" fa-battery-half")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-quarter"
  }), _vm._v(" fa-battery-quarter")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-battery-three-quarters"
  }), _vm._v("\n                    fa-battery-three-quarters\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bed"
  }), _vm._v(" fa-bed")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-beer"
  }), _vm._v(" fa-beer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bell"
  }), _vm._v(" fa-bell")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bell-o"
  }), _vm._v(" fa-bell-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bell-slash"
  }), _vm._v(" fa-bell-slash")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bell-slash-o"
  }), _vm._v(" fa-bell-slash-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bicycle"
  }), _vm._v(" fa-bicycle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-binoculars"
  }), _vm._v(" fa-binoculars")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-birthday-cake"
  }), _vm._v(" fa-birthday-cake")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bolt"
  }), _vm._v(" fa-bolt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bomb"
  }), _vm._v(" fa-bomb")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-book"
  }), _vm._v(" fa-book")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bookmark"
  }), _vm._v(" fa-bookmark")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bookmark-o"
  }), _vm._v(" fa-bookmark-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-briefcase"
  }), _vm._v(" fa-briefcase")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bug"
  }), _vm._v(" fa-bug")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-building"
  }), _vm._v(" fa-building")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-building-o"
  }), _vm._v(" fa-building-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bullhorn"
  }), _vm._v(" fa-bullhorn")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bullseye"
  }), _vm._v(" fa-bullseye")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bus"
  }), _vm._v(" fa-bus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cab"
  }), _vm._v(" fa-cab "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calculator"
  }), _vm._v(" fa-calculator")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  }), _vm._v(" fa-calendar")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar-check-o"
  }), _vm._v(" fa-calendar-check-o\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar-minus-o"
  }), _vm._v(" fa-calendar-minus-o\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar-o"
  }), _vm._v(" fa-calendar-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar-plus-o"
  }), _vm._v(" fa-calendar-plus-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar-times-o"
  }), _vm._v(" fa-calendar-times-o\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-camera"
  }), _vm._v(" fa-camera")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-camera-retro"
  }), _vm._v(" fa-camera-retro")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-car"
  }), _vm._v(" fa-car")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-square-o-down"
  }), _vm._v("\n                    fa-caret-square-o-down\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-square-o-left"
  }), _vm._v("\n                    fa-caret-square-o-left\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-square-o-right"
  }), _vm._v("\n                    fa-caret-square-o-right\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-square-o-up"
  }), _vm._v(" fa-caret-square-o-up\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cart-arrow-down"
  }), _vm._v(" fa-cart-arrow-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cart-plus"
  }), _vm._v(" fa-cart-plus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc"
  }), _vm._v(" fa-cc")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-certificate"
  }), _vm._v(" fa-certificate")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  }), _vm._v(" fa-check")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-circle"
  }), _vm._v(" fa-check-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-circle-o"
  }), _vm._v(" fa-check-circle-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square"
  }), _vm._v(" fa-check-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square-o"
  }), _vm._v(" fa-check-square-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-child"
  }), _vm._v(" fa-child")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle"
  }), _vm._v(" fa-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle-o"
  }), _vm._v(" fa-circle-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle-o-notch"
  }), _vm._v(" fa-circle-o-notch")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle-thin"
  }), _vm._v(" fa-circle-thin")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-clock-o"
  }), _vm._v(" fa-clock-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-clone"
  }), _vm._v(" fa-clone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-close"
  }), _vm._v(" fa-close "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cloud"
  }), _vm._v(" fa-cloud")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cloud-download"
  }), _vm._v(" fa-cloud-download")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cloud-upload"
  }), _vm._v(" fa-cloud-upload")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-code"
  }), _vm._v(" fa-code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-code-fork"
  }), _vm._v(" fa-code-fork")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-coffee"
  }), _vm._v(" fa-coffee")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cog"
  }), _vm._v(" fa-cog")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cogs"
  }), _vm._v(" fa-cogs")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-comment"
  }), _vm._v(" fa-comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-comment-o"
  }), _vm._v(" fa-comment-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-commenting"
  }), _vm._v(" fa-commenting")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-commenting-o"
  }), _vm._v(" fa-commenting-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-comments"
  }), _vm._v(" fa-comments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-comments-o"
  }), _vm._v(" fa-comments-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-compass"
  }), _vm._v(" fa-compass")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-copyright"
  }), _vm._v(" fa-copyright")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-creative-commons"
  }), _vm._v(" fa-creative-commons\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-credit-card"
  }), _vm._v(" fa-credit-card")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-crop"
  }), _vm._v(" fa-crop")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-crosshairs"
  }), _vm._v(" fa-crosshairs")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cube"
  }), _vm._v(" fa-cube")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cubes"
  }), _vm._v(" fa-cubes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cutlery"
  }), _vm._v(" fa-cutlery")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-dashboard"
  }), _vm._v(" fa-dashboard\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-database"
  }), _vm._v(" fa-database")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-desktop"
  }), _vm._v(" fa-desktop")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-diamond"
  }), _vm._v(" fa-diamond")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-dot-circle-o"
  }), _vm._v(" fa-dot-circle-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-download"
  }), _vm._v(" fa-download")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  }), _vm._v(" fa-edit "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-h"
  }), _vm._v(" fa-ellipsis-h")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-v"
  }), _vm._v(" fa-ellipsis-v")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  }), _vm._v(" fa-envelope")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope-o"
  }), _vm._v(" fa-envelope-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope-square"
  }), _vm._v(" fa-envelope-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-eraser"
  }), _vm._v(" fa-eraser")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exchange"
  }), _vm._v(" fa-exchange")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exclamation"
  }), _vm._v(" fa-exclamation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exclamation-circle"
  }), _vm._v(" fa-exclamation-circle\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exclamation-triangle"
  }), _vm._v("\n                    fa-exclamation-triangle\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-external-link"
  }), _vm._v(" fa-external-link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-external-link-square"
  }), _vm._v("\n                    fa-external-link-square\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-eye"
  }), _vm._v(" fa-eye")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-eye-slash"
  }), _vm._v(" fa-eye-slash")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-eyedropper"
  }), _vm._v(" fa-eyedropper")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fax"
  }), _vm._v(" fa-fax")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-feed"
  }), _vm._v(" fa-feed "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-female"
  }), _vm._v(" fa-female")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fighter-jet"
  }), _vm._v(" fa-fighter-jet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-archive-o"
  }), _vm._v(" fa-file-archive-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-audio-o"
  }), _vm._v(" fa-file-audio-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-code-o"
  }), _vm._v(" fa-file-code-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-excel-o"
  }), _vm._v(" fa-file-excel-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-image-o"
  }), _vm._v(" fa-file-image-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-movie-o"
  }), _vm._v(" fa-file-movie-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o"
  }), _vm._v(" fa-file-pdf-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-photo-o"
  }), _vm._v(" fa-file-photo-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-picture-o"
  }), _vm._v(" fa-file-picture-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-powerpoint-o"
  }), _vm._v(" fa-file-powerpoint-o\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-sound-o"
  }), _vm._v(" fa-file-sound-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-video-o"
  }), _vm._v(" fa-file-video-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-word-o"
  }), _vm._v(" fa-file-word-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-zip-o"
  }), _vm._v(" fa-file-zip-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-film"
  }), _vm._v(" fa-film")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-filter"
  }), _vm._v(" fa-filter")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fire"
  }), _vm._v(" fa-fire")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fire-extinguisher"
  }), _vm._v(" fa-fire-extinguisher\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-flag"
  }), _vm._v(" fa-flag")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-flag-checkered"
  }), _vm._v(" fa-flag-checkered")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-flag-o"
  }), _vm._v(" fa-flag-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-flash"
  }), _vm._v(" fa-flash "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-flask"
  }), _vm._v(" fa-flask")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-folder"
  }), _vm._v(" fa-folder")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-folder-o"
  }), _vm._v(" fa-folder-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-folder-open"
  }), _vm._v(" fa-folder-open")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-folder-open-o"
  }), _vm._v(" fa-folder-open-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-frown-o"
  }), _vm._v(" fa-frown-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-futbol-o"
  }), _vm._v(" fa-futbol-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gamepad"
  }), _vm._v(" fa-gamepad")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gavel"
  }), _vm._v(" fa-gavel")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gear"
  }), _vm._v(" fa-gear "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gears"
  }), _vm._v(" fa-gears "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gift"
  }), _vm._v(" fa-gift")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-glass"
  }), _vm._v(" fa-glass")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-globe"
  }), _vm._v(" fa-globe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-graduation-cap"
  }), _vm._v(" fa-graduation-cap")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-group"
  }), _vm._v(" fa-group "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-grab-o"
  }), _vm._v(" fa-hand-grab-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-lizard-o"
  }), _vm._v(" fa-hand-lizard-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-paper-o"
  }), _vm._v(" fa-hand-paper-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-peace-o"
  }), _vm._v(" fa-hand-peace-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-pointer-o"
  }), _vm._v(" fa-hand-pointer-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-rock-o"
  }), _vm._v(" fa-hand-rock-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-scissors-o"
  }), _vm._v(" fa-hand-scissors-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-spock-o"
  }), _vm._v(" fa-hand-spock-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-stop-o"
  }), _vm._v(" fa-hand-stop-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hdd-o"
  }), _vm._v(" fa-hdd-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-headphones"
  }), _vm._v(" fa-headphones")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-heart"
  }), _vm._v(" fa-heart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-heart-o"
  }), _vm._v(" fa-heart-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-heartbeat"
  }), _vm._v(" fa-heartbeat")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-history"
  }), _vm._v(" fa-history")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-home"
  }), _vm._v(" fa-home")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hotel"
  }), _vm._v(" fa-hotel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass"
  }), _vm._v(" fa-hourglass")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-1"
  }), _vm._v(" fa-hourglass-1\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-2"
  }), _vm._v(" fa-hourglass-2\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-3"
  }), _vm._v(" fa-hourglass-3\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-end"
  }), _vm._v(" fa-hourglass-end")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-half"
  }), _vm._v(" fa-hourglass-half")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-o"
  }), _vm._v(" fa-hourglass-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hourglass-start"
  }), _vm._v(" fa-hourglass-start")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-i-cursor"
  }), _vm._v(" fa-i-cursor")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-image"
  }), _vm._v(" fa-image "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-inbox"
  }), _vm._v(" fa-inbox")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-industry"
  }), _vm._v(" fa-industry")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-info"
  }), _vm._v(" fa-info")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-info-circle"
  }), _vm._v(" fa-info-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-institution"
  }), _vm._v(" fa-institution\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-key"
  }), _vm._v(" fa-key")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-keyboard-o"
  }), _vm._v(" fa-keyboard-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-language"
  }), _vm._v(" fa-language")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-laptop"
  }), _vm._v(" fa-laptop")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-leaf"
  }), _vm._v(" fa-leaf")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-legal"
  }), _vm._v(" fa-legal "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-lemon-o"
  }), _vm._v(" fa-lemon-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-level-down"
  }), _vm._v(" fa-level-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-level-up"
  }), _vm._v(" fa-level-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-life-bouy"
  }), _vm._v(" fa-life-bouy\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-life-buoy"
  }), _vm._v(" fa-life-buoy\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-life-ring"
  }), _vm._v(" fa-life-ring")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-life-saver"
  }), _vm._v(" fa-life-saver\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-lightbulb-o"
  }), _vm._v(" fa-lightbulb-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart"
  }), _vm._v(" fa-line-chart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-location-arrow"
  }), _vm._v(" fa-location-arrow")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-lock"
  }), _vm._v(" fa-lock")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-magic"
  }), _vm._v(" fa-magic")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-magnet"
  }), _vm._v(" fa-magnet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mail-forward"
  }), _vm._v(" fa-mail-forward\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mail-reply"
  }), _vm._v(" fa-mail-reply\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mail-reply-all"
  }), _vm._v(" fa-mail-reply-all\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-male"
  }), _vm._v(" fa-male")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map"
  }), _vm._v(" fa-map")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-marker"
  }), _vm._v(" fa-map-marker")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-o"
  }), _vm._v(" fa-map-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-pin"
  }), _vm._v(" fa-map-pin")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-signs"
  }), _vm._v(" fa-map-signs")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-meh-o"
  }), _vm._v(" fa-meh-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-microphone"
  }), _vm._v(" fa-microphone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-microphone-slash"
  }), _vm._v(" fa-microphone-slash\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-minus"
  }), _vm._v(" fa-minus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-minus-circle"
  }), _vm._v(" fa-minus-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-minus-square"
  }), _vm._v(" fa-minus-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-minus-square-o"
  }), _vm._v(" fa-minus-square-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mobile"
  }), _vm._v(" fa-mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mobile-phone"
  }), _vm._v(" fa-mobile-phone\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-money"
  }), _vm._v(" fa-money")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-moon-o"
  }), _vm._v(" fa-moon-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mortar-board"
  }), _vm._v(" fa-mortar-board\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-motorcycle"
  }), _vm._v(" fa-motorcycle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mouse-pointer"
  }), _vm._v(" fa-mouse-pointer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-music"
  }), _vm._v(" fa-music")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-navicon"
  }), _vm._v(" fa-navicon\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-newspaper-o"
  }), _vm._v(" fa-newspaper-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-object-group"
  }), _vm._v(" fa-object-group")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-object-ungroup"
  }), _vm._v(" fa-object-ungroup")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-paint-brush"
  }), _vm._v(" fa-paint-brush")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-paper-plane"
  }), _vm._v(" fa-paper-plane")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-paper-plane-o"
  }), _vm._v(" fa-paper-plane-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-paw"
  }), _vm._v(" fa-paw")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil"
  }), _vm._v(" fa-pencil")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil-square"
  }), _vm._v(" fa-pencil-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil-square-o"
  }), _vm._v(" fa-pencil-square-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-phone"
  }), _vm._v(" fa-phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-phone-square"
  }), _vm._v(" fa-phone-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-photo"
  }), _vm._v(" fa-photo "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-picture-o"
  }), _vm._v(" fa-picture-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pie-chart"
  }), _vm._v(" fa-pie-chart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plane"
  }), _vm._v(" fa-plane")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plug"
  }), _vm._v(" fa-plug")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  }), _vm._v(" fa-plus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-circle"
  }), _vm._v(" fa-plus-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-square"
  }), _vm._v(" fa-plus-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-square-o"
  }), _vm._v(" fa-plus-square-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-power-off"
  }), _vm._v(" fa-power-off")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-print"
  }), _vm._v(" fa-print")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-puzzle-piece"
  }), _vm._v(" fa-puzzle-piece")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-qrcode"
  }), _vm._v(" fa-qrcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question"
  }), _vm._v(" fa-question")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-question-circle"
  }), _vm._v(" fa-question-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-quote-left"
  }), _vm._v(" fa-quote-left")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-quote-right"
  }), _vm._v(" fa-quote-right")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-random"
  }), _vm._v(" fa-random")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-recycle"
  }), _vm._v(" fa-recycle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-refresh"
  }), _vm._v(" fa-refresh")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-registered"
  }), _vm._v(" fa-registered")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-remove"
  }), _vm._v(" fa-remove\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reorder"
  }), _vm._v(" fa-reorder\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  }), _vm._v(" fa-reply")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply-all"
  }), _vm._v(" fa-reply-all")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-retweet"
  }), _vm._v(" fa-retweet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-road"
  }), _vm._v(" fa-road")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rocket"
  }), _vm._v(" fa-rocket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rss"
  }), _vm._v(" fa-rss")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rss-square"
  }), _vm._v(" fa-rss-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-search"
  }), _vm._v(" fa-search")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-search-minus"
  }), _vm._v(" fa-search-minus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-search-plus"
  }), _vm._v(" fa-search-plus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-send"
  }), _vm._v(" fa-send "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-send-o"
  }), _vm._v(" fa-send-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-server"
  }), _vm._v(" fa-server")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-share"
  }), _vm._v(" fa-share")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-share-alt"
  }), _vm._v(" fa-share-alt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-share-alt-square"
  }), _vm._v(" fa-share-alt-square\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-share-square"
  }), _vm._v(" fa-share-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-share-square-o"
  }), _vm._v(" fa-share-square-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-shield"
  }), _vm._v(" fa-shield")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ship"
  }), _vm._v(" fa-ship")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-shopping-cart"
  }), _vm._v(" fa-shopping-cart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-in"
  }), _vm._v(" fa-sign-in")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" fa-sign-out")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-signal"
  }), _vm._v(" fa-signal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sitemap"
  }), _vm._v(" fa-sitemap")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sliders"
  }), _vm._v(" fa-sliders")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-smile-o"
  }), _vm._v(" fa-smile-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-soccer-ball-o"
  }), _vm._v(" fa-soccer-ball-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort"
  }), _vm._v(" fa-sort")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-alpha-asc"
  }), _vm._v(" fa-sort-alpha-asc")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-alpha-desc"
  }), _vm._v(" fa-sort-alpha-desc")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-amount-asc"
  }), _vm._v(" fa-sort-amount-asc")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-amount-desc"
  }), _vm._v(" fa-sort-amount-desc\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-asc"
  }), _vm._v(" fa-sort-asc")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-desc"
  }), _vm._v(" fa-sort-desc")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-down"
  }), _vm._v(" fa-sort-down\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-numeric-asc"
  }), _vm._v(" fa-sort-numeric-asc\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-numeric-desc"
  }), _vm._v(" fa-sort-numeric-desc\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sort-up"
  }), _vm._v(" fa-sort-up\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-space-shuttle"
  }), _vm._v(" fa-space-shuttle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-spinner"
  }), _vm._v(" fa-spinner")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-spoon"
  }), _vm._v(" fa-spoon")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-square"
  }), _vm._v(" fa-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-square-o"
  }), _vm._v(" fa-square-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-star"
  }), _vm._v(" fa-star")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-star-half"
  }), _vm._v(" fa-star-half")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-star-half-empty"
  }), _vm._v(" fa-star-half-empty\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-star-half-full"
  }), _vm._v(" fa-star-half-full\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-star-half-o"
  }), _vm._v(" fa-star-half-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-star-o"
  }), _vm._v(" fa-star-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sticky-note"
  }), _vm._v(" fa-sticky-note")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sticky-note-o"
  }), _vm._v(" fa-sticky-note-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-street-view"
  }), _vm._v(" fa-street-view")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-suitcase"
  }), _vm._v(" fa-suitcase")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sun-o"
  }), _vm._v(" fa-sun-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-support"
  }), _vm._v(" fa-support\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tablet"
  }), _vm._v(" fa-tablet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tachometer"
  }), _vm._v(" fa-tachometer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag"
  }), _vm._v(" fa-tag")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tags"
  }), _vm._v(" fa-tags")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tasks"
  }), _vm._v(" fa-tasks")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-taxi"
  }), _vm._v(" fa-taxi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-television"
  }), _vm._v(" fa-television")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-terminal"
  }), _vm._v(" fa-terminal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-thumb-tack"
  }), _vm._v(" fa-thumb-tack")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-thumbs-down"
  }), _vm._v(" fa-thumbs-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-thumbs-o-down"
  }), _vm._v(" fa-thumbs-o-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-thumbs-o-up"
  }), _vm._v(" fa-thumbs-o-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-thumbs-up"
  }), _vm._v(" fa-thumbs-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ticket"
  }), _vm._v(" fa-ticket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times"
  }), _vm._v(" fa-times")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times-circle"
  }), _vm._v(" fa-times-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times-circle-o"
  }), _vm._v(" fa-times-circle-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tint"
  }), _vm._v(" fa-tint")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-down"
  }), _vm._v(" fa-toggle-down\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-left"
  }), _vm._v(" fa-toggle-left\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-off"
  }), _vm._v(" fa-toggle-off")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-on"
  }), _vm._v(" fa-toggle-on")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-right"
  }), _vm._v(" fa-toggle-right\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-up"
  }), _vm._v(" fa-toggle-up\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trademark"
  }), _vm._v(" fa-trademark")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash"
  }), _vm._v(" fa-trash")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash-o"
  }), _vm._v(" fa-trash-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tree"
  }), _vm._v(" fa-tree")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trophy"
  }), _vm._v(" fa-trophy")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-truck"
  }), _vm._v(" fa-truck")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tty"
  }), _vm._v(" fa-tty")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tv"
  }), _vm._v(" fa-tv\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-umbrella"
  }), _vm._v(" fa-umbrella")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-university"
  }), _vm._v(" fa-university")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-unlock"
  }), _vm._v(" fa-unlock")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-unlock-alt"
  }), _vm._v(" fa-unlock-alt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-unsorted"
  }), _vm._v(" fa-unsorted\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-upload"
  }), _vm._v(" fa-upload")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user"
  }), _vm._v(" fa-user")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user-plus"
  }), _vm._v(" fa-user-plus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user-secret"
  }), _vm._v(" fa-user-secret")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user-times"
  }), _vm._v(" fa-user-times")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-users"
  }), _vm._v(" fa-users")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-video-camera"
  }), _vm._v(" fa-video-camera")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-volume-down"
  }), _vm._v(" fa-volume-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-volume-off"
  }), _vm._v(" fa-volume-off")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-volume-up"
  }), _vm._v(" fa-volume-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-warning"
  }), _vm._v(" fa-warning\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-wheelchair"
  }), _vm._v(" fa-wheelchair")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-wifi"
  }), _vm._v(" fa-wifi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-wrench"
  }), _vm._v(" fa-wrench")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "hand"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Hand Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-grab-o"
  }), _vm._v(" fa-hand-grab-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-lizard-o"
  }), _vm._v(" fa-hand-lizard-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-o-down"
  }), _vm._v(" fa-hand-o-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-o-left"
  }), _vm._v(" fa-hand-o-left")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-o-right"
  }), _vm._v(" fa-hand-o-right")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-o-up"
  }), _vm._v(" fa-hand-o-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-paper-o"
  }), _vm._v(" fa-hand-paper-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-peace-o"
  }), _vm._v(" fa-hand-peace-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-pointer-o"
  }), _vm._v(" fa-hand-pointer-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-rock-o"
  }), _vm._v(" fa-hand-rock-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-scissors-o"
  }), _vm._v(" fa-hand-scissors-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-spock-o"
  }), _vm._v(" fa-hand-spock-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-stop-o"
  }), _vm._v(" fa-hand-stop-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-thumbs-down"
  }), _vm._v(" fa-thumbs-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-thumbs-o-down"
  }), _vm._v(" fa-thumbs-o-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-thumbs-o-up"
  }), _vm._v(" fa-thumbs-o-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-thumbs-up"
  }), _vm._v(" fa-thumbs-up")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "transportation"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Transportation Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ambulance"
  }), _vm._v(" fa-ambulance")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-automobile"
  }), _vm._v(" fa-automobile\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bicycle"
  }), _vm._v(" fa-bicycle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bus"
  }), _vm._v(" fa-bus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cab"
  }), _vm._v(" fa-cab "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-car"
  }), _vm._v(" fa-car")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fighter-jet"
  }), _vm._v(" fa-fighter-jet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-motorcycle"
  }), _vm._v(" fa-motorcycle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plane"
  }), _vm._v(" fa-plane")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rocket"
  }), _vm._v(" fa-rocket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ship"
  }), _vm._v(" fa-ship")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-space-shuttle"
  }), _vm._v(" fa-space-shuttle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-subway"
  }), _vm._v(" fa-subway")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-taxi"
  }), _vm._v(" fa-taxi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-train"
  }), _vm._v(" fa-train")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-truck"
  }), _vm._v(" fa-truck")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-wheelchair"
  }), _vm._v(" fa-wheelchair")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "gender"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Gender Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-genderless"
  }), _vm._v(" fa-genderless")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-intersex"
  }), _vm._v(" fa-intersex\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mars"
  }), _vm._v(" fa-mars")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mars-double"
  }), _vm._v(" fa-mars-double")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mars-stroke"
  }), _vm._v(" fa-mars-stroke")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mars-stroke-h"
  }), _vm._v(" fa-mars-stroke-h")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mars-stroke-v"
  }), _vm._v(" fa-mars-stroke-v")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mercury"
  }), _vm._v(" fa-mercury")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-neuter"
  }), _vm._v(" fa-neuter")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-transgender"
  }), _vm._v(" fa-transgender")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-transgender-alt"
  }), _vm._v(" fa-transgender-alt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-venus"
  }), _vm._v(" fa-venus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-venus-double"
  }), _vm._v(" fa-venus-double")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-venus-mars"
  }), _vm._v(" fa-venus-mars")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "file-type"
    }
  }, [_c('h2', {
    staticClass: "page-header"
  }, [_vm._v("File Type Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file"
  }), _vm._v(" fa-file")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-archive-o"
  }), _vm._v(" fa-file-archive-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-audio-o"
  }), _vm._v(" fa-file-audio-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-code-o"
  }), _vm._v(" fa-file-code-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-excel-o"
  }), _vm._v(" fa-file-excel-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-image-o"
  }), _vm._v(" fa-file-image-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-movie-o"
  }), _vm._v(" fa-file-movie-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-o"
  }), _vm._v(" fa-file-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o"
  }), _vm._v(" fa-file-pdf-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-photo-o"
  }), _vm._v(" fa-file-photo-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-picture-o"
  }), _vm._v(" fa-file-picture-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-powerpoint-o"
  }), _vm._v(" fa-file-powerpoint-o\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-sound-o"
  }), _vm._v(" fa-file-sound-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text"
  }), _vm._v(" fa-file-text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text-o"
  }), _vm._v(" fa-file-text-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-video-o"
  }), _vm._v(" fa-file-video-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-word-o"
  }), _vm._v(" fa-file-word-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-zip-o"
  }), _vm._v(" fa-file-zip-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "spinner"
    }
  }, [_c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Spinner Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle-o-notch"
  }), _vm._v(" fa-circle-o-notch")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cog"
  }), _vm._v(" fa-cog")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gear"
  }), _vm._v(" fa-gear "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-refresh"
  }), _vm._v(" fa-refresh")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-spinner"
  }), _vm._v(" fa-spinner")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "form-control"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Form Control Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square"
  }), _vm._v(" fa-check-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square-o"
  }), _vm._v(" fa-check-square-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle"
  }), _vm._v(" fa-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle-o"
  }), _vm._v(" fa-circle-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-dot-circle-o"
  }), _vm._v(" fa-dot-circle-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-minus-square"
  }), _vm._v(" fa-minus-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-minus-square-o"
  }), _vm._v(" fa-minus-square-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-square"
  }), _vm._v(" fa-plus-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-square-o"
  }), _vm._v(" fa-plus-square-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-square"
  }), _vm._v(" fa-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-square-o"
  }), _vm._v(" fa-square-o")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "payment"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Payment Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-amex"
  }), _vm._v(" fa-cc-amex")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-diners-club"
  }), _vm._v(" fa-cc-diners-club")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-discover"
  }), _vm._v(" fa-cc-discover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-jcb"
  }), _vm._v(" fa-cc-jcb")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-mastercard"
  }), _vm._v(" fa-cc-mastercard")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-paypal"
  }), _vm._v(" fa-cc-paypal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-stripe"
  }), _vm._v(" fa-cc-stripe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-visa"
  }), _vm._v(" fa-cc-visa")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-credit-card"
  }), _vm._v(" fa-credit-card")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-google-wallet"
  }), _vm._v(" fa-google-wallet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-paypal"
  }), _vm._v(" fa-paypal")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "chart"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Chart Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-area-chart"
  }), _vm._v(" fa-area-chart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bar-chart"
  }), _vm._v(" fa-bar-chart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bar-chart-o"
  }), _vm._v(" fa-bar-chart-o\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart"
  }), _vm._v(" fa-line-chart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pie-chart"
  }), _vm._v(" fa-pie-chart")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "currency"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Currency Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bitcoin"
  }), _vm._v(" fa-bitcoin\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btc"
  }), _vm._v(" fa-btc")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cny"
  }), _vm._v(" fa-cny "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-dollar"
  }), _vm._v(" fa-dollar\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-eur"
  }), _vm._v(" fa-eur")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-euro"
  }), _vm._v(" fa-euro "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gbp"
  }), _vm._v(" fa-gbp")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gg"
  }), _vm._v(" fa-gg")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gg-circle"
  }), _vm._v(" fa-gg-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ils"
  }), _vm._v(" fa-ils")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-inr"
  }), _vm._v(" fa-inr")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-jpy"
  }), _vm._v(" fa-jpy")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-krw"
  }), _vm._v(" fa-krw")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-money"
  }), _vm._v(" fa-money")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rmb"
  }), _vm._v(" fa-rmb "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rouble"
  }), _vm._v(" fa-rouble\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rub"
  }), _vm._v(" fa-rub")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ruble"
  }), _vm._v(" fa-ruble "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rupee"
  }), _vm._v(" fa-rupee "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-shekel"
  }), _vm._v(" fa-shekel\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sheqel"
  }), _vm._v(" fa-sheqel\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-try"
  }), _vm._v(" fa-try")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-turkish-lira"
  }), _vm._v(" fa-turkish-lira\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-usd"
  }), _vm._v(" fa-usd")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-won"
  }), _vm._v(" fa-won "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-yen"
  }), _vm._v(" fa-yen "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "text-editor"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Text Editor Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-align-center"
  }), _vm._v(" fa-align-center")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-align-justify"
  }), _vm._v(" fa-align-justify")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-align-left"
  }), _vm._v(" fa-align-left")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-align-right"
  }), _vm._v(" fa-align-right")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bold"
  }), _vm._v(" fa-bold")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chain"
  }), _vm._v(" fa-chain "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chain-broken"
  }), _vm._v(" fa-chain-broken")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-clipboard"
  }), _vm._v(" fa-clipboard")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-columns"
  }), _vm._v(" fa-columns")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-copy"
  }), _vm._v(" fa-copy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cut"
  }), _vm._v(" fa-cut "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-dedent"
  }), _vm._v(" fa-dedent\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-eraser"
  }), _vm._v(" fa-eraser")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file"
  }), _vm._v(" fa-file")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-o"
  }), _vm._v(" fa-file-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text"
  }), _vm._v(" fa-file-text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text-o"
  }), _vm._v(" fa-file-text-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-files-o"
  }), _vm._v(" fa-files-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-floppy-o"
  }), _vm._v(" fa-floppy-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-font"
  }), _vm._v(" fa-font")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-header"
  }), _vm._v(" fa-header")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-indent"
  }), _vm._v(" fa-indent")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-italic"
  }), _vm._v(" fa-italic")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-link"
  }), _vm._v(" fa-link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list"
  }), _vm._v(" fa-list")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-alt"
  }), _vm._v(" fa-list-alt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ol"
  }), _vm._v(" fa-list-ol")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul"
  }), _vm._v(" fa-list-ul")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-outdent"
  }), _vm._v(" fa-outdent")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-paperclip"
  }), _vm._v(" fa-paperclip")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-paragraph"
  }), _vm._v(" fa-paragraph")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-paste"
  }), _vm._v(" fa-paste "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-repeat"
  }), _vm._v(" fa-repeat")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rotate-left"
  }), _vm._v(" fa-rotate-left\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rotate-right"
  }), _vm._v(" fa-rotate-right\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  }), _vm._v(" fa-save "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-scissors"
  }), _vm._v(" fa-scissors")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-strikethrough"
  }), _vm._v(" fa-strikethrough")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-subscript"
  }), _vm._v(" fa-subscript")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-superscript"
  }), _vm._v(" fa-superscript")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-table"
  }), _vm._v(" fa-table")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-text-height"
  }), _vm._v(" fa-text-height")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-text-width"
  }), _vm._v(" fa-text-width")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-th"
  }), _vm._v(" fa-th")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-th-large"
  }), _vm._v(" fa-th-large")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-th-list"
  }), _vm._v(" fa-th-list")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-underline"
  }), _vm._v(" fa-underline")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-undo"
  }), _vm._v(" fa-undo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-unlink"
  }), _vm._v(" fa-unlink\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "directional"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Directional Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-double-down"
  }), _vm._v(" fa-angle-double-down\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-double-left"
  }), _vm._v(" fa-angle-double-left\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-double-right"
  }), _vm._v(" fa-angle-double-right\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-double-up"
  }), _vm._v(" fa-angle-double-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  }), _vm._v(" fa-angle-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-left"
  }), _vm._v(" fa-angle-left")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-right"
  }), _vm._v(" fa-angle-right")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-up"
  }), _vm._v(" fa-angle-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-circle-down"
  }), _vm._v(" fa-arrow-circle-down\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-circle-left"
  }), _vm._v(" fa-arrow-circle-left\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-circle-o-down"
  }), _vm._v("\n                    fa-arrow-circle-o-down\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-circle-o-left"
  }), _vm._v("\n                    fa-arrow-circle-o-left\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-circle-o-right"
  }), _vm._v("\n                    fa-arrow-circle-o-right\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-circle-o-up"
  }), _vm._v(" fa-arrow-circle-o-up\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-circle-right"
  }), _vm._v(" fa-arrow-circle-right\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-circle-up"
  }), _vm._v(" fa-arrow-circle-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-down"
  }), _vm._v(" fa-arrow-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-left"
  }), _vm._v(" fa-arrow-left")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-right"
  }), _vm._v(" fa-arrow-right")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrow-up"
  }), _vm._v(" fa-arrow-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrows"
  }), _vm._v(" fa-arrows")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrows-alt"
  }), _vm._v(" fa-arrows-alt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrows-h"
  }), _vm._v(" fa-arrows-h")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrows-v"
  }), _vm._v(" fa-arrows-v")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-down"
  }), _vm._v(" fa-caret-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-left"
  }), _vm._v(" fa-caret-left")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-right"
  }), _vm._v(" fa-caret-right")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-square-o-down"
  }), _vm._v("\n                    fa-caret-square-o-down\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-square-o-left"
  }), _vm._v("\n                    fa-caret-square-o-left\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-square-o-right"
  }), _vm._v("\n                    fa-caret-square-o-right\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-square-o-up"
  }), _vm._v(" fa-caret-square-o-up\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-caret-up"
  }), _vm._v(" fa-caret-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chevron-circle-down"
  }), _vm._v("\n                    fa-chevron-circle-down\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chevron-circle-left"
  }), _vm._v("\n                    fa-chevron-circle-left\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chevron-circle-right"
  }), _vm._v("\n                    fa-chevron-circle-right\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chevron-circle-up"
  }), _vm._v(" fa-chevron-circle-up\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chevron-down"
  }), _vm._v(" fa-chevron-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chevron-left"
  }), _vm._v(" fa-chevron-left")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chevron-right"
  }), _vm._v(" fa-chevron-right")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chevron-up"
  }), _vm._v(" fa-chevron-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exchange"
  }), _vm._v(" fa-exchange")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-o-down"
  }), _vm._v(" fa-hand-o-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-o-left"
  }), _vm._v(" fa-hand-o-left")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-o-right"
  }), _vm._v(" fa-hand-o-right")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hand-o-up"
  }), _vm._v(" fa-hand-o-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-long-arrow-down"
  }), _vm._v(" fa-long-arrow-down")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-long-arrow-left"
  }), _vm._v(" fa-long-arrow-left")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-long-arrow-right"
  }), _vm._v(" fa-long-arrow-right\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-long-arrow-up"
  }), _vm._v(" fa-long-arrow-up")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-down"
  }), _vm._v(" fa-toggle-down\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-left"
  }), _vm._v(" fa-toggle-left\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-right"
  }), _vm._v(" fa-toggle-right\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-toggle-up"
  }), _vm._v(" fa-toggle-up\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "video-player"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Video Player Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-arrows-alt"
  }), _vm._v(" fa-arrows-alt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-backward"
  }), _vm._v(" fa-backward")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-compress"
  }), _vm._v(" fa-compress")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-eject"
  }), _vm._v(" fa-eject")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-expand"
  }), _vm._v(" fa-expand")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fast-backward"
  }), _vm._v(" fa-fast-backward")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fast-forward"
  }), _vm._v(" fa-fast-forward")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-forward"
  }), _vm._v(" fa-forward")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pause"
  }), _vm._v(" fa-pause")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-play"
  }), _vm._v(" fa-play")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-play-circle"
  }), _vm._v(" fa-play-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-play-circle-o"
  }), _vm._v(" fa-play-circle-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-random"
  }), _vm._v(" fa-random")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-step-backward"
  }), _vm._v(" fa-step-backward")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-step-forward"
  }), _vm._v(" fa-step-forward")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-stop"
  }), _vm._v(" fa-stop")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-youtube-play"
  }), _vm._v(" fa-youtube-play")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "brand"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Brand Icons")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('ul', {
    staticClass: "margin-bottom-none padding-left-lg"
  }, [_c('li', [_vm._v("All brand icons are trademarks of their respective owners.")]), _vm._v(" "), _c('li', [_vm._v("The use of these trademarks does not indicate endorsement of the trademark holder by Font\n                      Awesome, nor vice versa.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row fontawesome-icon-list"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-500px"
  }), _vm._v(" fa-500px")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-adn"
  }), _vm._v(" fa-adn")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-amazon"
  }), _vm._v(" fa-amazon")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-android"
  }), _vm._v(" fa-android")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angellist"
  }), _vm._v(" fa-angellist")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-apple"
  }), _vm._v(" fa-apple")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-behance"
  }), _vm._v(" fa-behance")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-behance-square"
  }), _vm._v(" fa-behance-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bitbucket"
  }), _vm._v(" fa-bitbucket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bitbucket-square"
  }), _vm._v(" fa-bitbucket-square\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bitcoin"
  }), _vm._v(" fa-bitcoin\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-black-tie"
  }), _vm._v(" fa-black-tie")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btc"
  }), _vm._v(" fa-btc")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-buysellads"
  }), _vm._v(" fa-buysellads")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-amex"
  }), _vm._v(" fa-cc-amex")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-diners-club"
  }), _vm._v(" fa-cc-diners-club")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-discover"
  }), _vm._v(" fa-cc-discover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-jcb"
  }), _vm._v(" fa-cc-jcb")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-mastercard"
  }), _vm._v(" fa-cc-mastercard")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-paypal"
  }), _vm._v(" fa-cc-paypal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-stripe"
  }), _vm._v(" fa-cc-stripe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cc-visa"
  }), _vm._v(" fa-cc-visa")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-chrome"
  }), _vm._v(" fa-chrome")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-codepen"
  }), _vm._v(" fa-codepen")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-connectdevelop"
  }), _vm._v(" fa-connectdevelop")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-contao"
  }), _vm._v(" fa-contao")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-css3"
  }), _vm._v(" fa-css3")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-dashcube"
  }), _vm._v(" fa-dashcube")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-delicious"
  }), _vm._v(" fa-delicious")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-deviantart"
  }), _vm._v(" fa-deviantart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-digg"
  }), _vm._v(" fa-digg")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-dribbble"
  }), _vm._v(" fa-dribbble")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-dropbox"
  }), _vm._v(" fa-dropbox")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-drupal"
  }), _vm._v(" fa-drupal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-empire"
  }), _vm._v(" fa-empire")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-expeditedssl"
  }), _vm._v(" fa-expeditedssl")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-facebook"
  }), _vm._v(" fa-facebook")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-facebook-f"
  }), _vm._v(" fa-facebook-f\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-facebook-official"
  }), _vm._v(" fa-facebook-official\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-facebook-square"
  }), _vm._v(" fa-facebook-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-firefox"
  }), _vm._v(" fa-firefox")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-flickr"
  }), _vm._v(" fa-flickr")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-fonticons"
  }), _vm._v(" fa-fonticons")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-forumbee"
  }), _vm._v(" fa-forumbee")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-foursquare"
  }), _vm._v(" fa-foursquare")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ge"
  }), _vm._v(" fa-ge\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-get-pocket"
  }), _vm._v(" fa-get-pocket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gg"
  }), _vm._v(" fa-gg")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gg-circle"
  }), _vm._v(" fa-gg-circle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-git"
  }), _vm._v(" fa-git")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-git-square"
  }), _vm._v(" fa-git-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-github"
  }), _vm._v(" fa-github")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-github-alt"
  }), _vm._v(" fa-github-alt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-github-square"
  }), _vm._v(" fa-github-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gittip"
  }), _vm._v(" fa-gittip\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-google"
  }), _vm._v(" fa-google")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-google-plus"
  }), _vm._v(" fa-google-plus")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-google-plus-square"
  }), _vm._v(" fa-google-plus-square\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-google-wallet"
  }), _vm._v(" fa-google-wallet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-gratipay"
  }), _vm._v(" fa-gratipay")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hacker-news"
  }), _vm._v(" fa-hacker-news")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-houzz"
  }), _vm._v(" fa-houzz")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-html5"
  }), _vm._v(" fa-html5")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-instagram"
  }), _vm._v(" fa-instagram")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-internet-explorer"
  }), _vm._v(" fa-internet-explorer\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ioxhost"
  }), _vm._v(" fa-ioxhost")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-joomla"
  }), _vm._v(" fa-joomla")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-jsfiddle"
  }), _vm._v(" fa-jsfiddle")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-lastfm"
  }), _vm._v(" fa-lastfm")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-lastfm-square"
  }), _vm._v(" fa-lastfm-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-leanpub"
  }), _vm._v(" fa-leanpub")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-linkedin"
  }), _vm._v(" fa-linkedin")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-linkedin-square"
  }), _vm._v(" fa-linkedin-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-linux"
  }), _vm._v(" fa-linux")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-maxcdn"
  }), _vm._v(" fa-maxcdn")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-meanpath"
  }), _vm._v(" fa-meanpath")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-medium"
  }), _vm._v(" fa-medium")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-odnoklassniki"
  }), _vm._v(" fa-odnoklassniki")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-odnoklassniki-square"
  }), _vm._v("\n                    fa-odnoklassniki-square\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-opencart"
  }), _vm._v(" fa-opencart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-openid"
  }), _vm._v(" fa-openid")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-opera"
  }), _vm._v(" fa-opera")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-optin-monster"
  }), _vm._v(" fa-optin-monster")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pagelines"
  }), _vm._v(" fa-pagelines")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-paypal"
  }), _vm._v(" fa-paypal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pied-piper"
  }), _vm._v(" fa-pied-piper")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pied-piper-alt"
  }), _vm._v(" fa-pied-piper-alt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pinterest"
  }), _vm._v(" fa-pinterest")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pinterest-p"
  }), _vm._v(" fa-pinterest-p")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pinterest-square"
  }), _vm._v(" fa-pinterest-square\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-qq"
  }), _vm._v(" fa-qq")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ra"
  }), _vm._v(" fa-ra\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-rebel"
  }), _vm._v(" fa-rebel")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reddit"
  }), _vm._v(" fa-reddit")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reddit-square"
  }), _vm._v(" fa-reddit-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-renren"
  }), _vm._v(" fa-renren")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-safari"
  }), _vm._v(" fa-safari")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sellsy"
  }), _vm._v(" fa-sellsy")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-share-alt"
  }), _vm._v(" fa-share-alt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-share-alt-square"
  }), _vm._v(" fa-share-alt-square\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-shirtsinbulk"
  }), _vm._v(" fa-shirtsinbulk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-simplybuilt"
  }), _vm._v(" fa-simplybuilt")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-skyatlas"
  }), _vm._v(" fa-skyatlas")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-skype"
  }), _vm._v(" fa-skype")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-slack"
  }), _vm._v(" fa-slack")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-slideshare"
  }), _vm._v(" fa-slideshare")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-soundcloud"
  }), _vm._v(" fa-soundcloud")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-spotify"
  }), _vm._v(" fa-spotify")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-stack-exchange"
  }), _vm._v(" fa-stack-exchange")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-stack-overflow"
  }), _vm._v(" fa-stack-overflow")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-steam"
  }), _vm._v(" fa-steam")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-steam-square"
  }), _vm._v(" fa-steam-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-stumbleupon"
  }), _vm._v(" fa-stumbleupon")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-stumbleupon-circle"
  }), _vm._v(" fa-stumbleupon-circle\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tencent-weibo"
  }), _vm._v(" fa-tencent-weibo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trello"
  }), _vm._v(" fa-trello")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tripadvisor"
  }), _vm._v(" fa-tripadvisor")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tumblr"
  }), _vm._v(" fa-tumblr")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tumblr-square"
  }), _vm._v(" fa-tumblr-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-twitch"
  }), _vm._v(" fa-twitch")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-twitter"
  }), _vm._v(" fa-twitter")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-twitter-square"
  }), _vm._v(" fa-twitter-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-viacoin"
  }), _vm._v(" fa-viacoin")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-vimeo"
  }), _vm._v(" fa-vimeo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-vimeo-square"
  }), _vm._v(" fa-vimeo-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-vine"
  }), _vm._v(" fa-vine")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-vk"
  }), _vm._v(" fa-vk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-wechat"
  }), _vm._v(" fa-wechat\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-weibo"
  }), _vm._v(" fa-weibo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-weixin"
  }), _vm._v(" fa-weixin")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-whatsapp"
  }), _vm._v(" fa-whatsapp")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-wikipedia-w"
  }), _vm._v(" fa-wikipedia-w")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-windows"
  }), _vm._v(" fa-windows")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-wordpress"
  }), _vm._v(" fa-wordpress")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-xing"
  }), _vm._v(" fa-xing")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-xing-square"
  }), _vm._v(" fa-xing-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-y-combinator"
  }), _vm._v(" fa-y-combinator")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-y-combinator-square"
  }), _vm._v("\n                    fa-y-combinator-square "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-yahoo"
  }), _vm._v(" fa-yahoo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-yc"
  }), _vm._v(" fa-yc\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-yc-square"
  }), _vm._v(" fa-yc-square\n                    "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-yelp"
  }), _vm._v(" fa-yelp")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-youtube"
  }), _vm._v(" fa-youtube")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-youtube-play"
  }), _vm._v(" fa-youtube-play")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-youtube-square"
  }), _vm._v(" fa-youtube-square")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "medical"
    }
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v("Medical Icons")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ambulance"
  }), _vm._v(" fa-ambulance")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-h-square"
  }), _vm._v(" fa-h-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-heart"
  }), _vm._v(" fa-heart")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-heart-o"
  }), _vm._v(" fa-heart-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-heartbeat"
  }), _vm._v(" fa-heartbeat")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-hospital-o"
  }), _vm._v(" fa-hospital-o")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-medkit"
  }), _vm._v(" fa-medkit")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-square"
  }), _vm._v(" fa-plus-square")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-stethoscope"
  }), _vm._v(" fa-stethoscope")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user-md"
  }), _vm._v(" fa-user-md")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-wheelchair"
  }), _vm._v(" fa-wheelchair")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "glyphicons"
    }
  }, [_c('ul', {
    staticClass: "bs-glyphicons"
  }, [_c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-asterisk"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-asterisk")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-plus")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-euro"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-euro")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-eur"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-eur")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-minus")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-cloud"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-cloud")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-envelope")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-pencil"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-pencil")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-glass"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-glass")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-music"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-music")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-search")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-heart"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-heart")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-star"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-star")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-star-empty"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-star-empty")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-user")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-film"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-film")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-th-large"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-th-large")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-th"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-th")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-th-list"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-th-list")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-ok"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-ok")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-remove"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-remove")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-zoom-in"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-zoom-in")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-zoom-out"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-zoom-out")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-off"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-off")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-signal"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-signal")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-cog")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-trash")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-home")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-file")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-time"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-time")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-road"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-road")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-download-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-download-alt")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-download"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-download")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-upload"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-upload")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-inbox"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-inbox")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-play-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-play-circle")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-repeat"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-repeat")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-refresh")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-list-alt")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-lock"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-lock")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-flag"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-flag")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-headphones"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-headphones")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-volume-off"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-volume-off")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-volume-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-volume-down")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-volume-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-volume-up")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-qrcode"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-qrcode")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-barcode"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-barcode")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-tag"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-tag")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-tags"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-tags")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-book")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-bookmark"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-bookmark")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-print"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-print")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-camera"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-camera")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-font"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-font")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-bold"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-bold")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-italic"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-italic")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-text-height"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-text-height")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-text-width"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-text-width")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-align-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-align-left")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-align-center"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-align-center")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-align-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-align-right")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-align-justify"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-align-justify")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-list"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-list")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-indent-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-indent-left")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-indent-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-indent-right")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-facetime-video")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-picture"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-picture")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-map-marker"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-map-marker")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-adjust"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-adjust")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-tint"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-tint")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-edit"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-edit")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-share"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-share")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-check")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-move"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-move")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-step-backward"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-step-backward")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-fast-backward"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-fast-backward")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-backward"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-backward")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-play"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-play")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-pause"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-pause")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-stop"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-stop")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-forward"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-forward")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-fast-forward"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-fast-forward")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-step-forward"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-step-forward")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-eject"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-eject")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-chevron-left")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-chevron-right")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-plus-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-plus-sign")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-minus-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-minus-sign")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-remove-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-remove-sign")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-ok-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-ok-sign")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-question-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-question-sign")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-info-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-info-sign")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-screenshot"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-screenshot")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-remove-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-remove-circle")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-ok-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-ok-circle")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-ban-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-ban-circle")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-arrow-left")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-arrow-right")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-arrow-up")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-arrow-down")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-share-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-share-alt")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-resize-full"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-resize-full")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-resize-small"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-resize-small")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-exclamation-sign")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-gift"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-gift")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-leaf"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-leaf")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-fire"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-fire")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-eye-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-eye-open")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-eye-close"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-eye-close")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-warning-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-warning-sign")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-plane"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-plane")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-calendar")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-random"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-random")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-comment"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-comment")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-magnet"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-magnet")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-chevron-up")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-chevron-down")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-retweet"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-retweet")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-shopping-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-shopping-cart")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-folder-close"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-folder-close")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-folder-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-folder-open")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-resize-vertical"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-resize-vertical")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-resize-horizontal"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-resize-horizontal")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-hdd"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-hdd")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-bullhorn"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-bullhorn")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-bell")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-certificate"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-certificate")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-thumbs-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-thumbs-up")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-thumbs-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-thumbs-down")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-hand-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-hand-right")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-hand-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-hand-left")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-hand-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-hand-up")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-hand-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-hand-down")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-circle-arrow-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-circle-arrow-right")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-circle-arrow-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-circle-arrow-left")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-circle-arrow-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-circle-arrow-up")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-circle-arrow-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-circle-arrow-down")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-globe")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-wrench"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-wrench")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-tasks")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-filter"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-filter")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-briefcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-briefcase")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-fullscreen"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-fullscreen")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-dashboard"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-dashboard")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-paperclip"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-paperclip")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-heart-empty"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-heart-empty")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-link"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-link")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-phone"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-phone")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-pushpin"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-pushpin")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-usd"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-usd")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-gbp"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-gbp")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sort"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sort")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sort-by-alphabet"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sort-by-alphabet")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sort-by-alphabet-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sort-by-alphabet-alt")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sort-by-order"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sort-by-order")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sort-by-order-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sort-by-order-alt")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sort-by-attributes"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sort-by-attributes")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sort-by-attributes-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sort-by-attributes-alt")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-unchecked"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-unchecked")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-expand"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-expand")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-collapse-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-collapse-down")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-collapse-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-collapse-up")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-log-in"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-log-in")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-flash"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-flash")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-log-out"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-log-out")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-new-window"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-new-window")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-record"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-record")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-save"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-save")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-open")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-saved"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-saved")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-import"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-import")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-export"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-export")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-send"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-send")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-floppy-disk"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-floppy-disk")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-floppy-saved"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-floppy-saved")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-floppy-remove"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-floppy-remove")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-floppy-save"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-floppy-save")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-floppy-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-floppy-open")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-credit-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-credit-card")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-transfer"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-transfer")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-cutlery"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-cutlery")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-header"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-header")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-compressed"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-compressed")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-earphone"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-earphone")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-phone-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-phone-alt")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-tower"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-tower")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-stats"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-stats")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sd-video"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sd-video")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-hd-video"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-hd-video")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-subtitles"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-subtitles")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sound-stereo"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sound-stereo")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sound-dolby"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sound-dolby")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sound-5-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sound-5-1")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sound-6-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sound-6-1")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sound-7-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sound-7-1")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-copyright-mark"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-copyright-mark")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-registration-mark"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-registration-mark")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-cloud-download"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-cloud-download")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-cloud-upload"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-cloud-upload")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-tree-conifer"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-tree-conifer")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-tree-deciduous"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-tree-deciduous")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-cd"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-cd")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-save-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-save-file")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-open-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-open-file")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-level-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-level-up")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-copy")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-paste"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-paste")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-alert"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-alert")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-equalizer"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-equalizer")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-king"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-king")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-queen"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-queen")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-pawn"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-pawn")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-bishop"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-bishop")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-knight"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-knight")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-baby-formula"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-baby-formula")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-tent"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-tent")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-blackboard"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-blackboard")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-bed"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-bed")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-apple"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-apple")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-erase"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-erase")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-hourglass"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-hourglass")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-lamp"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-lamp")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-duplicate"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-duplicate")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-piggy-bank"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-piggy-bank")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-scissors"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-scissors")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-bitcoin"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-bitcoin")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-btc"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-btc")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-xbt"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-xbt")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-yen"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-yen")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-jpy"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-jpy")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-ruble"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-ruble")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-rub"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-rub")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-scale"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-scale")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-ice-lolly"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-ice-lolly")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-ice-lolly-tasted"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-ice-lolly-tasted")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-education"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-education")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-option-horizontal"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-option-horizontal")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-option-vertical"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-option-vertical")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-menu-hamburger"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-menu-hamburger")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-modal-window"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-modal-window")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-oil"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-oil")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-grain"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-grain")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-sunglasses"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-sunglasses")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-text-size"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-text-size")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-text-color"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-text-color")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-text-background"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-text-background")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-object-align-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-object-align-top")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-object-align-bottom"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-object-align-bottom")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-object-align-horizontal"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-object-align-horizontal")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-object-align-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-object-align-left")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-object-align-vertical"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-object-align-vertical")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-object-align-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-object-align-right")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-triangle-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-triangle-right")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-triangle-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-triangle-left")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-triangle-bottom")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-triangle-top")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-console"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-console")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-superscript"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-superscript")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-subscript"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-subscript")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-menu-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-menu-left")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-menu-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-menu-right")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-menu-down")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-menu-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon-class"
  }, [_vm._v("glyphicon glyphicon-menu-up")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9c084372!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ui/Icons.vue
// module id = 2049
// module chunks = 1